import { render, staticRenderFns } from "./ProductSelectionFertilizer.vue?vue&type=template&id=3560d184&lang=html&"
import script from "./ProductSelectionFertilizer.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionFertilizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports